import { render, staticRenderFns } from "./ColumnWithDataLabelsMulti.vue?vue&type=template&id=8a814316&scoped=true&"
import script from "./ColumnWithDataLabelsMulti.vue?vue&type=script&lang=js&"
export * from "./ColumnWithDataLabelsMulti.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a814316",
  null
  
)

export default component.exports